import { FormattedMessage } from 'react-intl';
import { getLink } from '../../common/FormatMessageComponents';
import styles from './reCaptchaDisclaimer.scss';

const ReCaptchaDisclaimer = () => (
  <span className={styles.disclaimer}>
    <FormattedMessage
      id="enter.reCaptchaDisclaimer"
      defaultMessage="This site is protected by reCAPTCHA and the Google <policyLink>Privacy Policy</policyLink> and <termsLink>Terms of Service</termsLink> apply."
      description="Disclaimer on login and signup forms about reCaptcha."
      values={{
        policyLink: getLink('https://policies.google.com/privacy', true),
        termsLink: getLink('https://policies.google.com/terms', true),
      }}
    />
  </span>
);

export default ReCaptchaDisclaimer;
